const loginStageConstants = {
    LOGIN: 'login',
    RESETPASSWORD: "resetpassword",
};

export default loginStageConstants;
